import { createContext } from 'react';

export const AuthContext = createContext({
  isLoading: true,
  user: null,
  isSignedIn: false,
});
